import { PaymentInstrumentV1Dto, PaymentMethod, PaymentProvider } from './api';

// Core domain types for payment processing
export type { PaymentMethod, PaymentProvider };
export type Environment = 'test' | 'sandbox' | 'live';
export type Region = 'eu-central-1' | 'us-east-2' | 'ap-southeast-4';

export const DEFAULT_REGION: Region = 'eu-central-1';

export interface SavedPaymentMethod extends PaymentInstrumentV1Dto {
    id: string;
}
